import http from './../../core/services/http.service';
import ExportsService from "@/core/services/exports.service";
import {AppSettings} from "@/shared/AppSettings";

export default {
  getCustomers(params = null, expand = '') {
    return http.get(`/api/v1/customers/?expand=${expand}`, {params});
  },
  getCustomerAddresses(uuid, params = null) {
    return http.get(`/api/v1/customers/${uuid}/addresses/`, {params});
  },
  getCustomerLinks(uuid, expand = '', params = null) {
    return http.get(`/api/v1/customers/${uuid}/links/?expand=${expand}`, {params});
  },
  getCustomerNotes(uuid, params = null) {
    return http.get(`/api/v1/customers/${uuid}/notes/`, {params});
  },
  getCustomer(id, expand = '', params = null) {
    return http.get(`/api/v1/customers/${id}/?expand=${expand}`, {params});
  },
  getTaxStatuses(id, params = null) {
    return http.get(`/api/v1/tax-statuses/`, {params});
  },
  updateCustomer(id, data, expand = '') {
    return http.put(`/api/v1/customers/${id}/?expand=${expand}`, data);
  },
  createCustomer(data) {
    return http.post('/api/v1/customers/', data);
  },
  updateOrCreateCustomer(data) {
    if (!data.uuid) {
      return this.createCustomer(data);
    }
    return this.updateCustomer(data.uuid, data);
  },
  partialUpdateCustomer(payload, expand='') {
    return http.patch(`/api/v1/customers/${payload.id}/?expand=${expand}`, payload.data);
  },
  partialUpdateCustomerTerms(payload) {
    return http.patch(`/api/v1/customers/terms/${payload.id}/`, payload.data);
  },
  createOrUpdateBankAccount(data) {
    return http.post(`/api/v1/customers/bank-accounts/`, data);
  },
  getSwiftFromIban(data) {
    return http.post(`/api/v1/customers/bank-accounts/get-swift-code/`, data, {}, true);
  },
  removeBankAccount(uuid) {
    return http.delete(`/api/v1/customers/bank-accounts/${uuid}/`);
  },
  removeCustomer(uuid) {
    return http.delete(`/api/v1/customers/${uuid}`)
  },
  getGeneralFields() {
    return {
      translatableFields: [],
    }
  },
  async getCustomerInterests(params) {
    let response = await http.get(`/api/v1/customers/dashboard/items-by-category/`, {params});

    const returnData = {
      buyer: [],
      vendor: []
    };

    if (response.success) {
      response.body.buyer.forEach(item => returnData.buyer.push({name: item.key, value: item.value}));
      response.body.vendor.forEach(item => returnData.vendor.push({name: item.key, value: item.value}));
    }

    return returnData;
  },
  async getCustomerGeneralInfo(params) {
    return http.get(`/api/v1/customers/dashboard/general-info/`, {params});
  },
  getCustomerReservations(params = null) {
    return http.get(`/api/v1/customers/reservations/`, {params});
  },
  removeCustomerReservation(uuid) {
    return http.delete(`/api/v1/customers/reservations/${uuid}/`)
  },
  updateCustomerReservation(id, data, expand = 'auction,currency') {
    return http.put(`/api/v1/customers/reservations/${id}/?expand=${expand}`, data);
  },
  createCustomerReservation(data, expand = 'auction,currency') {
    return http.post(`/api/v1/customers/reservations/?expand=${expand}`, data);
  },
  async getCustomerFinancialActivity(params) {
    const response = await http.get(`/api/v1/customers/dashboard/financial-activity/`, {params});

    const returnData = {
      buyer: {labels: [], series: []},
      vendor: {labels: [], series: []}
    };


    if (response.success) {

      for (let currencyCode in response.body.vendor) {
        if (returnData.vendor.labels.length === 0) {
          returnData.vendor.labels = Object.keys(response.body.vendor[currencyCode])
        }

        let tmpSeriesObj = {name: currencyCode, data: []}
        for (let date in response.body.vendor[currencyCode]) {
          tmpSeriesObj.data.push(response.body.vendor[currencyCode][date])
        }
        returnData.vendor.series.push(tmpSeriesObj)
      }

      for (let currencyCode in response.body.buyer) {
        if (returnData.buyer.labels.length === 0) {
          returnData.buyer.labels = Object.keys(response.body.buyer[currencyCode])
        }

        let tmpSeriesObj = {name: currencyCode, data: []}
        for (let date in response.body.buyer[currencyCode]) {
          tmpSeriesObj.data.push(response.body.buyer[currencyCode][date])
        }
        returnData.buyer.series.push(tmpSeriesObj)
      }

    }

    return returnData;
  },
  createCustomerLogo(formData, id, onUploadProgress) {
    return http.put(`/api/v1/customers/${id}/logo/?expand=logo`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}, onUploadProgress
    });
  },
  deleteCustomerLogo({id}) {
    return http.delete(`/api/v1/customers/${id}/logo/`)
  },
  updateCustomerEmailsToTemplates({id, data}) {
    return http.put(`/api/v1/customers/${id}/bulk-email-to-template/`, data);
  },
  updateCustomerIdentification(payload) {
    return http.patch(`/api/v1/customers/identifications/${payload.id}/?expand=customer_identification_files.attachment.presigned_url`, payload.data);
  },
  getCustomerIdentification(customer_uuid) {
    return http.get(`/api/v1/customers/identifications/${customer_uuid}/?expand=customer_identification_files.attachment.presigned_url`);
  },
  createTrustLevel(data) {
    return http.post(`/api/v1/customers/trust-levels/`, data);
  },
  updateTrustLevel(uuid, data) {
    return http.put(`/api/v1/customers/trust-levels/${uuid}/`, data);
  },
  getCustomerAttachment(uuid){
    return http.get(`/api/v1/customers/customer-attachment/${uuid}/?expand=presigned_url`)
  },
  getCustomerOptins(id) {
    return http.get(`/api/v1/customers/${id}/optins/`);
  },
  createCustomerOptins(id, data) {
    return http.post(`/api/v1/customers/${id}/optins/`, data);
  },
  async downloadBankDetailsBulkTemplate() {
    let response = await ExportsService.generateToken();

    if (!response.success) {
      return false;
    }

    window.open(AppSettings.url() + `/api/v1/customers/bank-details-bulk-upload-template/?token=${response.body.token}`, '_blank')
  },
  uploadBankDetailsBulkTemplate(data, onUploadProgress) {
    return http.post('/api/v1/customers/bank-details-bulk-upload/', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: onUploadProgress
    });
  },
  createOrUpdateTermsDynamicFields(id, data) {
    return http.patch(`/api/v1/customers/${id}/terms-dynamic-fields/`, data);
  },
  getOnlinePaymentMethods(params = null) {
    return http.get(`/api/v1/payments/online-payment-methods/`, {params});
  },
};
